var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Datepicker',{attrs:{"inline":true,"language":_vm.language,"format":_vm.DatePickerFormat,"highlighted":_vm.highlighted,"disabled-dates":_vm.daysOut90Days,"calendar-class":"calendarStyle"}})}
var staticRenderFns = []

export { render, staticRenderFns }